import React from 'react';
import styled from 'styled-components';
import { Header, Logo, Text, ActionsBar, HorizontalGroup } from '@libs/uikit/Components';

const StyledHorizontalGroup = styled(HorizontalGroup)`
    height: 100%;
`;

const StyledActionsBar = styled(ActionsBar)`
    justify-content: space-between;
    width: 100%;
    height: 100%;
    padding-top: 7px;
`;

export const FlexHeader = () => {
    const refreshPage = () => window.location.replace(window.location.origin + window.location.pathname);

    return (
        <Header>
            <StyledActionsBar>
                <StyledHorizontalGroup>
                    <div onClick={refreshPage}>
                        <Logo onClick={refreshPage}/>
                    </div>
                    <sup>
                        <sup>
                            <Text inline>| Flex&trade; Tag Generator</Text>
                        </sup>
                    </sup>
                </StyledHorizontalGroup>
            </StyledActionsBar>
        </Header>
    );
};
